import type { Membership } from "../models";

export function membershipUserTenantKey(
  userId: string,
  tenantId: string
): string {
  return `${userId}:${tenantId}`;
}

export function membershipUniqueKey(
  userId: string,
  tenantId: string,
  roleId: string
): string {
  return `${userId}:${tenantId}:${roleId}`;
}

/** Déduplique par utilisateur + tenant + rôle — le plus récent l'emporte. */
export function normalizeMemberships(memberships: Membership[]): Membership[] {
  const sorted = [...memberships].sort(
    (a, b) =>
      new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  );
  const byKey = new Map<string, Membership>();
  for (const membership of sorted) {
    const key = membershipUniqueKey(
      membership.userId,
      membership.tenantId,
      membership.roleId
    );
    if (!byKey.has(key)) {
      byKey.set(key, membership);
    }
  }
  return [...byKey.values()];
}

export function getUserMemberships(
  memberships: Membership[],
  userId: string,
  tenantId?: string
): Membership[] {
  return normalizeMemberships(memberships).filter(
    (m) =>
      m.userId === userId &&
      m.status === "active" &&
      (!tenantId || m.tenantId === tenantId)
  );
}

/** @deprecated Préférer getUserMemberships — conservé pour compat API. */
export function pickPrimaryMembership(
  memberships: Membership[],
  userId: string,
  tenantId?: string
): Membership | undefined {
  return getUserMemberships(memberships, userId, tenantId)[0];
}
